export default __webpack_public_path__ + "static/media/search.e9a536ac.svg";